module.exports = __webpack_public_path__ + "images/loader.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/loader.gif
// module id = 2366
// module chunks = 0